import React from 'react';
import { useNavigate } from 'react-router-dom';
import { translations } from '../translations';
import '../styles/pages/SubscriptionResult.css';

function SubscriptionCancel({ language }) {
  const navigate = useNavigate();
  const t = translations[language];

  return (
    <div className="subscription-result-container">
      <div className="result-card cancel">
        <div className="result-icon cancel-icon">✕</div>
        <h1>{t.subscriptionCancelTitle || 'Payment Cancelled'}</h1>
        <p className="result-message">
          {t.subscriptionCancelMessage || 'Your payment was cancelled. No charges have been made.'}
        </p>
        <div className="result-buttons">
          <button 
            className="result-button secondary"
            onClick={() => navigate('/subscription')}
          >
            {t.tryAgain || 'Try Again'}
          </button>
          <button 
            className="result-button"
            onClick={() => navigate('/')}
          >
            {t.goToHome || 'Go to Home'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCancel;
